"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regions = void 0;
var Regions;
(function (Regions) {
    Regions["US"] = "us";
    Regions["EU"] = "eu";
    Regions["AP"] = "ap";
})(Regions || (exports.Regions = Regions = {}));
